import React, { useMemo } from 'react';
export function LabelIcons(_ref) {
  var titleId = _ref.titleId,
    formContext = _ref.formContext,
    uiSchema = _ref.uiSchema,
    children = _ref.children;
  var _useLabelIcons = useLabelIcons(titleId, formContext, uiSchema),
    iconIds = _useLabelIcons.iconIds,
    labelIcons = _useLabelIcons.labelIcons;
  return children({
    iconIds: iconIds,
    labelIcons: labelIcons
  });
}
export function useLabelIcons(labelId, formContext, uiSchema, options) {
  return useMemo(function () {
    var _options = options || (uiSchema ? uiSchema['ui:options'] : undefined);
    var uiIcons = getLabelIcons(labelId, {
      icons: _options ? _options.icons || [] : [],
      formContext: formContext
    });
    var iconIds = uiIcons ? uiIcons.map(function (icon) {
      return icon.id;
    }) : [];
    var labelIcons = uiIcons ? uiIcons.map(function (icon) {
      return icon.component;
    }) : [];
    var labelledBy = "".concat(labelId, " ").concat(iconIds.join(' '));
    return {
      labelledBy: labelledBy,
      labelIcons: labelIcons
    };
  }, [labelId, formContext, uiSchema, options]);
}
export default function getLabelIcons(controlId, _ref2) {
  var icons = _ref2.icons,
    formContext = _ref2.formContext;
  if (!icons || !formContext || !formContext.icons) {
    return null;
  }
  var result = [];
  var iconsRegistry = formContext.icons;
  icons.forEach(function (icon) {
    var IconComponent = iconsRegistry[icon];
    if (IconComponent) {
      var iconId = "".concat(controlId, "--").concat(icon);
      result.push({
        id: iconId,
        component: /*#__PURE__*/React.createElement(IconComponent, {
          id: iconId
        })
      });
    }
  });
  return result;
}